import NavigationController, { STATECHANGEEVENT } from "./NavigationController";

import Utils from "../utils/Utils";

export default class UrlController {
    constructor(fc, pathoffset = null) {
        this._stickyGet = {};
        this._pathoffset = pathoffset;
        this.fc = fc;
        this.dataHelper = fc.dataHelper;
        this.interfaceController = fc.interface;
        this._historyChangeBind();
    }

    /**
     * Bind pop state ( navigation back ) here we want to handle switches to category or overview
     * @private
     */
    _historyChangeBind() {
        window.onpopstate = () => {
            let frontendController = this.fc,
                request = NavigationController.getPathname(),
                arg0 = request[0];
            if (arg0 === "" || arg0 === undefined || arg0 === "overview") {
                delete frontendController._issue_id;
                delete frontendController._spread_id;
                if (!frontendController._homepage) {
                    frontendController.interface.getInterfaceInstance().transitionToOverview();
                    frontendController._homepage = true;
                }
            }

            this.cleanUrlResolver(window.location.pathname.replace(/^\/|\/$/g, ""));
            if (!isNaN(+this.issue_id)) {
                if (+this.issue_id !== frontendController._issue_id) {
                    this._urlDelegate();
                }
            }
        };

        window.addEventListener(STATECHANGEEVENT, window.onpopstate);
    }

    bindUrlListener() {
        window.addEventListener(STATECHANGEEVENT, () => {
            this._urlDelegate();
        });
        window.addEventListener("popstate", () => {
            this._urlDelegate();
        });

        this._urlDelegate(true);
    }

    setLanguage(abbr) {
        this.fc.setLanguage(abbr);
        this._abbr = self.abbr = abbr;
        this.dataHelper.getLanguageId(this._abbr);
    }

    cleanUrlResolver(urlPath, first_time) {
        this._get = NavigationController.getGetParams();

        if (this._pathoffset !== null) {
            urlPath = urlPath.replace(this._pathoffset, "").replace(/^\/|\/$/g, "");
            if (!self._keephtml) {
                urlPath = urlPath.replace(".html", "");
            }
        }

        if (first_time && !Utils.isEmpty(window._first)) {
            if (window._first.issue_id) {
                this.dataHelper.getSpreadIdListOrder(window._first.issue_id);
                this.dataHelper.createCompleteUrlList();
            }
            this.setLanguage(window._first.abbr);
        }

        const url = this.dataHelper.getUrlList()[urlPath];
        if (!Utils.isEmpty(url)) {
            this.spread_id = parseInt(url.spread_id, 10);
            this.issue_id = parseInt(url.issue_id, 10);
            this.language = url.language;
            this.fc._homepage = false;
        } else {
            //url not found in url list
            let request = NavigationController.getPathname();
            this.spread_id = parseInt(request[2], 10);
            this.issue_id = parseInt(request[1], 10);
            this.language = request[0];
        }
    }

    _validateGet(key, value) {
        if (value != undefined) {
            if (value != this._stickyGet[key]) {
                this._stickyGet[key] = value;
            }
            return true;
        }
        return false;
    }

    _handleGetParamsDelegate() {
        let language = this._get["lang"];

        if (this._validateGet("lang", language)) {
            this.setLanguage(language);
        }

        this._validateGet("category", this._get["category"]);
        this._validateGet("recent", this._get["recent"]);
        this._validateGet("legacy", this._get["legacy"]);

        this.interfaceController.setStickyGet(this._stickyGet);
    }

    getCategoryFilter() {
        return this._stickyGet["category"] || this._stickyGet["recent"] || this._stickyGet["legacy"] || false;
    }

    handleHomePageLogic() {
        this._handleGetParamsDelegate();
        this.interfaceController.renderHomepage(this.getCategoryFilter());
        this.interfaceController._classInterface.transitionToOverview();
    }

    /**
     * The core of url change , we handle the logic here.
     * Always called when window state is changed
     *
     * @private _urlDelegate
     */
    _urlDelegate(first_time) {
        $("#loader").hide();
        const url = window.location.pathname.replace(/^\/|\/$/g, "");

        this.cleanUrlResolver(url, first_time);

        if (first_time === true) {
            // if we have a spread_id or issue_id on first call then render the front page a go on in urldelegate
            if (!isNaN(this.spread_id) && !isNaN(this.issue_id)) {
                if (!isNaN(this.spread_id)) {
                    this.fc.setFastLoad(window.fastload || window._first || false);

                    this.interfaceController.showViewerDirect();
                    this.fc.startIssue(this.issue_id, this.spread_id);
                    this.fc._urlChanged();
                    this.fc.setSpreadId(this.issue_id, this.spread_id, first_time);

                    this.fc.setFastLoad(false);
                    $("link[data-href]").attr("href", $("link[data-href]").data("href"));
                    return;
                }
            } else {
                // we only want homepage to render and then quit
                // if skipped spread
                const skipped = this.dataHelper.isSkippedSpread(url);
                if (skipped) {
                    const firstSpread = this.dataHelper.getFirstSpread(skipped.js_issue_issue_id);
                    NavigationController.pushState({}, firstSpread["spread_title"], `/${firstSpread.url}`);

                    return;
                }

                //eventueel hier ook nog oude pagina url niet gevonden redirect to first available.
                this.fc._homepage = true;
            }
        }

        //check if url contains an issue_id if not show homepage
        switch (this.issue_id) {
            case "magazine":
                location.reload();
                delete this.fc._issue_id;
                return false;
            case "overview.html":
                if (window.exportType === "ipad") {
                    delete this.fc._issue_id;
                    this.interfaceController.renderHomepage(undefined, this.language);
                    return false;
                }
        }

        if (this.fc._homepage) {
            this.fc.executeStopSpread();
            this.handleHomePageLogic();
            return false;
        }

        if (this.fc._issue_id !== this.issue_id && !isNaN(this.issue_id) && !isNaN(this.spread_id)) {
            this.fc.executeStopSpread();
            this.fc.startIssue(this.issue_id, this.spread_id); // check if issue is changed to new
        }

        if (!isNaN(this.issue_id)) {
            this.fc.setCurrentIssueId(this.issue_id);
            this.fc.dataHelper.filterAndOrderSpreads(this.issue_id);
        }

        //set active spread
        if (!isNaN(this.spread_id)) {
            this._spread_id = this.spread_id;
        }

        const spread = this.dataHelper.getSpreadById(this.fc._issue_id, this._spread_id);

        //spread does not exist
        if (Utils.isEmpty(spread)) {
            const first_spread_id = this.dataHelper.getFirstSpreadId(this.fc._issue_id);
            const spread = this.dataHelper.getSpreadById(this.fc._issue_id, first_spread_id);
            const spread_title = Utils.urlEncodeString(spread["spread_title"]);

            if (first_time == true) {
                this.fc.startIssue(this.issue_id, this.spread_id);
                this.fc._urlChanged();
                this.fc.fetchSpreadProxy(this.spread_id);
                this.fc.setSpreadId(this.issue_id, first_spread_id);
            } else {
                if (Utils.isEmpty(spread.url)) {
                    spread.url = `${this._abbr}/${this.issue_id}/${first_spread_id}/${spread_title}.html`;
                }
                NavigationController.pushState({}, spread["spread_title"], `/${spread.url}`);
            }

            return false; //Stop because url delegate will be called again.
        } else {
            //Final we reached a clean correct url so we start here
            this.fc.setCurrentSpreadId(this._spread_id);
            this.fc._urlChanged();

            return true;
        }
    }
}
